import { useEffect } from 'react';
import { ProfessionalSettings } from '../components/ProfessionalSettings.js';
import { useDrawer } from '../state/drawer.js';
import { useSession } from '../state/session.js';

export function SettingsPage() {
  const { user } = useSession();
  const drawer = useDrawer();
  useEffect(() => { drawer.setInfo({ title: 'Settings' }); }, [drawer.setInfo]);
  return <div className="page stack">
    <h1>Settings</h1>
    <p className="muted">Your choices for Jabberr. Appearance and theme are also available beside your name in the sidebar.</p>
    {user ? <ProfessionalSettings userId={user.id} /> : null}
  </div>;
}
